import MicroModal from "micromodal";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { differenceInSeconds, format } from "date-fns";
import axios from "axios";

import { Tooltippy, PopoverDashboard } from "../../actions/Tippy";
import Typography from "../Typography";
import Table from "../table";

import {
  getAttendanceType,
  addChat,
  addChatSimult,
  typingadd,
  AlterScreen,
  ShowInfoDisplay,
  clearConferenceExt,
  CallConsultaInterna,
  addMonitoring,
  addMonitoringSimult,
  EditTypeMonitorings,
  EditTypeMonitoringm,
  changeTransferQueue,
} from "../../actions";
import {
  InitialMonitoring,
  SharedScreen,
  changeDisplayByeChat,
} from "../../actions/websocket";
import { connection_platform } from "../../services/api";

import "../../build/css/modal.css";
import "./modals.css";

import { ReactComponent as IconClose } from "../../build/images/closecircle22px.svg";
import { ReactComponent as MessageIcon } from "../../build/images/viewactionmessage.svg";
import { ReactComponent as CallIcon } from "../../build/images/viewactioncall.svg";
import { ReactComponent as SussurroIcon } from "../../build/images/viewactionprofile.svg";
import { ReactComponent as PointMessageIcon } from "../../build/images/viewactionmessagepoint.svg";
import { ReactComponent as BlockIcon } from "../../build/images/viewactionblock.svg";
import { ReactComponent as ListeningIcon } from "../../build/images/teams/monitorias/sigilosa.svg";
import { ReactComponent as MoreIcon } from "../../build/images/moreinfo.svg";
import { ReactComponent as TRANSFERICON2 } from "../../build/images/icons/transfer-client-icon2.svg";
import { ReactComponent as ENCERRARATENDIMENTO } from "../../build/images/icons/byeatendant-client-icon.svg";
import { ReactComponent as EmptyState } from "../../build/images/emptystatemanagerhorizontal.svg";
import { ReactComponent as Transferir } from "../../build/images/popover-queue/redo.svg";

function defaultSorting(rowA, rowB, columnId) {
  const objectRowA = rowA.original[columnId].data.toLowerCase();
  const objectRowB = rowB.original[columnId].data.toLowerCase();

  if (objectRowA > objectRowB) return -1;
  if (objectRowB > objectRowA) return 1;

  return 0;
}

function defaultNumberSorting(rowA, rowB, columnId) {
  const objectRowA = rowA.original[columnId].data;
  const objectRowB = rowB.original[columnId].data;

  if (objectRowA > objectRowB) return -1;
  if (objectRowB > objectRowA) return 1;

  return 0;
}

function dateTimeSorting(rowA, rowB, columnId) {
  const dateRowA = rowA.original[columnId].config.customOrder;
  const dateRowB = rowB.original[columnId].config.customOrder;

  if (dateRowA > dateRowB) return -1;
  if (dateRowB > dateRowA) return 1;
  return 0;
}

// "DD/MM/AAAA às 15:00"
const dataDefault = [
  {
    start: {
      data: format(new Date(), "dd/MM/yyyy 'às' HH:mm"),
      config: {
        className: "cell-gray-text",
        customOrder: new Date(),
      },
    },
    number: {
      data: 999999999,
      config: {
        className: "cell-gray-text",
      },
    },
    // company: {
    //   data: "Ingenium System",
    //   config: {
    //     textEllipsis: true,
    //   },
    // },
    cdr: {
      data: 999999,
      config: {
        className: "cell-gray-text",
      },
    },
    lastMessageClient: {
      data: format(new Date(), "dd/MM/yyyy 'às' HH:mm"),
      config: {
        textEllipsis: true,
        customOrder: new Date(),
      },
    },
    lastMessageAgent: {
      data: format(new Date(), "dd/MM/yyyy 'às' HH:mm"),
      config: {
        customOrder: new Date(),
        className: "cell-gray-text",
      },
    },
    waitingClient: {
      data: format(new Date(), "HH:mm:ss"),
      config: {
        customOrder: new Date(),
        textEllipsis: true,
      },
    },
    waitingAgent: {
      data: format(new Date(), "HH:mm:ss"),
      config: {
        customOrder: new Date(),
        className: "",
      },
    },
    // actions: {
    //   data: "-",
    //   config: {
    //     className: "",
    //   },
    // },
  },
];

var port = localStorage.getItem("port");
var pathname = localStorage.getItem("pathname");

export default function SeeAtends({
  infos,
  setInfos,
  setActionsBlock,
  setInfoTransfer,
  infoTransfer,
  setMonitorDash,
  editTypeMonitoring,
  reduxMonitoringInitial,
}) {
  const [loading, setLoading] = useState(false);
  const [infosGeral, setInfosGeral] = useState(infos);
  const [dataTable, setDataTable] = useState(dataDefault);
  const [horaaction, setHoraAction] = useState("");
  const [duration, setDuration] = useState("");
  const [reasonaction, setReasonAction] = useState("");
  const [userout, setUserOut] = useState("");
  const [inable, setInable] = useState(false);
  const [act, setAct] = useState("1");
  const [actdesb, setActDesb] = useState("1001");
  const [idsup, setIdSup] = useState("");
  const [idblock, setIdBlock] = useState("");

  const ChatSimult = useSelector((state) => state.chatsimult);
  const InfoUsers = useSelector((state) => state.informationusers);
  const MonitoringSimult = useSelector((state) => state.monitoringsimult);

  const dispatch = useDispatch();

  const sortBy = {
    sortBy: [
      {
        id: "start",
        desc: false,
      },
    ],
  };

  let columns = [
    {
      Header: "Início",
      accessor: "start",
      Hint: "Início",
      id: "start",
      sortType: dateTimeSorting,
      disableFilters: true,
      display: true,
      // display: chooseDisplay("Início"),
    },
    {
      Header: "Número",
      accessor: "number",
      Hint: "Número",
      id: "number",
      disableFilters: true,
      sortType: defaultSorting,
      display: true,
      // display: chooseDisplay("Número"),
      // disableSortBy: true,
    },
    // {
    //   Header: "Empresa",
    //   accessor: "company",
    //   Hint: "Empresa",
    //   id: "company",
    //   disableFilters: true,
    //   sortType: defaultSorting,
    //   display: true,
    //   // display: chooseDisplay("Empresa"),
    // },
    {
      Header: "CDR",
      accessor: "cdr",
      Hint: "CDR",
      id: "cdr",
      disableFilters: true,
      sortType: defaultNumberSorting,
      display: true,
      // display: chooseDisplay("CDR"),
    },
    {
      Header: "Última Mensagem Cliente",
      accessor: "lastMessageClient",
      Hint: "Última Mensagem Cliente",
      id: "lastMessageClient",
      disableFilters: true,
      sortType: dateTimeSorting,
      display: true,
      // display: chooseDisplay("Última Mensagem Cliente"),
    },
    {
      Header: "Última Mensagem Atendente",
      accessor: "lastMessageAgent",
      Hint: "Última Mensagem Atendente",
      id: "lastMessageAgent",
      disableFilters: true,
      sortType: dateTimeSorting,
      display: true,
      // display: chooseDisplay("Última Mensagem Agente"),
    },
    {
      Header: "Cliente em espera",
      accessor: "waitingClient",
      Hint: "Cliente em espera",
      id: "waitingClient",
      disableFilters: true,
      sortType: dateTimeSorting,
      display: true,
      // display: chooseDisplay("Cliente em espera"),
    },
    {
      Header: "Atendente em espera",
      accessor: "waitingAgent",
      Hint: "Atendente em espera",
      id: "waitingAgent",
      disableFilters: true,
      sortType: dateTimeSorting,
      display: true,
      // display: chooseDisplay("Agente em espera"),
    },
    {
      Header: "Ações",
      accessor: "actions",
      Hint: "Ações",
      id: "actions",
      disableFilters: true,
      sortType: defaultSorting,
      display: true,
      disableSortBy: true,
    },
  ];

  function formatTime(segundos) {
    var horas = Math.floor(segundos / 3600);
    var minutos = Math.floor((segundos % 3600) / 60);
    var segundos = segundos % 60;

    return (
      horas.toString().padStart(2, "0") +
      ":" +
      minutos.toString().padStart(2, "0") +
      ":" +
      segundos.toString().padStart(2, "0")
    );
  }

  const handleInfos = async (iduser, type, cdrid) => {
    setLoading(true);
    let response = await getAttendanceType(iduser, type, cdrid);

    if (response && response.status === 200) {
      const data = response.data;

      if (data.length) {
        const formatData = data.map((datum) => {
          let timeClient = differenceInSeconds(
            new Date(),
            new Date(datum.ultima_msg_cliente)
          );
          let timeAgent = differenceInSeconds(
            new Date(),
            new Date(datum.ultima_msg_agente)
          );

          const actions =
            parseInt(datum.idmidia) !== 1
              ? {
                  data: (
                    <PopoverDashboard
                      trigger="click"
                      boundary="window"
                      placement="top"
                      multiple={true}
                      interactive={true}
                      content={renderTableOptions(
                        datum.id,
                        datum.serverid,
                        iduser,
                        datum.idmidia
                      )}
                    >
                      <MoreIcon style={{ cursor: "pointer" }} />
                    </PopoverDashboard>
                  ),
                  config: {
                    className: "",
                  },
                }
              : null; // ou você pode definir um objeto vazio se preferir

          return {
            start: {
              data: format(
                new Date(datum.data_inicio),
                "dd/MM/yyyy 'às' HH:mm"
              ),
              config: {
                className: "cell-gray-text",
                customOrder: new Date(datum.data_inicio),
              },
            },
            number: {
              data: datum.cliente,
              config: {
                className: "cell-gray-text",
              },
            },
            // company: {
            //   data: "Ingenium System",
            //   config: {
            //     textEllipsis: true,
            //   },
            // },
            cdr: {
              data: datum.id,
              config: {
                className: "cell-gray-text",
              },
            },
            lastMessageClient: {
              data: datum.ultima_msg_cliente
                ? format(
                    new Date(datum.ultima_msg_cliente),
                    "dd/MM/yyyy 'às' HH:mm"
                  )
                : "-",
              config: {
                textEllipsis: true,
                customOrder: new Date(datum.ultima_msg_cliente),
              },
            },
            lastMessageAgent: {
              data: datum.ultima_msg_agente
                ? format(
                    new Date(datum.ultima_msg_agente),
                    "dd/MM/yyyy 'às' HH:mm"
                  )
                : "-",
              config: {
                customOrder: new Date(datum.ultima_msg_agente),
                className: "cell-gray-text",
              },
            },
            waitingClient: {
              data:
                new Date(datum.ultima_msg_cliente) >
                new Date(datum.ultima_msg_agente)
                  ? formatTime(timeClient)
                  : "00:00:00",
              config: {
                customOrder: timeClient,
                textEllipsis: true,
              },
            },
            waitingAgent: {
              data:
                new Date(datum.ultima_msg_cliente) <
                new Date(datum.ultima_msg_agente)
                  ? formatTime(timeAgent)
                  : "00:00:00",
              config: {
                customOrder: timeAgent,
                className: "",
              },
            },
            actions,
          };
        });

        setDataTable(formatData);
      } else {
        setDataTable([]);
      }

      setInfoTransfer(false);
    } else {
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
      //   Toast(
      //     "Falha, não foi possível carregar as informações!",
      //     "Verifique sua conexão e tente novamente mais tarde",
      //     "error"
      //   );
    }
    setLoading(false);
  };

  const InitialChat = (user) => {
    reduxChatInitial(
      parseInt(user.iduser),
      user.label,
      true,
      false,
      user.ramal
    );
  };

  const reduxChatInitial = (iduser, displayname, active, opencall, ramal) => {
    let datatime = moment().format("YYYY/MM/DD HH:mm:ss");
    dispatch(
      addChatSimult(iduser, displayname, active, opencall, ramal, datatime)
    );
    dispatch(addChat(iduser, displayname, active, opencall, ramal, datatime));
    dispatch(typingadd(iduser, displayname));
    document.getElementById("simulation_click").click();
    // dispatch(AlterScreen('Atendentes'))
    // dispatch(ShowInfoDisplay('Atendentes'))
  };

  const InitialCall = (chatsimult, user) => {
    let erro = 0;

    if (chatsimult.length != 0) {
      chatsimult.map((chat) => {
        if (
          parseInt(chat.iduserout) === parseInt(user.iduser) &&
          chat.voz === false
        ) {
          erro = 1;
        } else if (
          parseInt(chat.iduserout) === parseInt(user.iduser) &&
          chat.voz === true
        ) {
          erro = 2;
        } else if (erro != 1 || erro != 2) {
          erro = 0;
        }
      });
      if (erro === 1) {
        reduxCallInitial(
          parseInt(user.iduser),
          user.label,
          user.ramal,
          user,
          true
        );
      } else if (erro === 2) {
        console.log("JA POSSUI CHAT ATIVO COM VOZ");
      } else {
        reduxCallInitial(
          parseInt(user.iduser),
          user.label,
          user.ramal,
          user,
          false
        );
      }
    } else {
      reduxCallInitial(
        parseInt(user.iduser),
        user.label,
        user.ramal,
        user,
        false
      );
    }
  };

  const reduxCallInitial = (iduser, label, ramal, user, isConference) => {
    if (isConference) {
      dispatch(clearConferenceExt());
      dispatch(CallConsultaInterna(ramal, iduser, user));
      // dispatch(AlterScreen('Atendentes'))
      // dispatch(ShowInfoDisplay('Atendentes'))
    } else {
      reduxChatInitial(iduser, label, true, false, ramal);
      dispatch(CallConsultaInterna(ramal, iduser, user));
    }
    document.getElementById("simulation_click").click();
  };

  const InitialMonitoringAction = (
    userin,
    userout,
    name,
    monitoringsimult,
    line,
    ramal,
    jsoncall
  ) => {
    let erro = 0;
    let auxline;
    if (monitoringsimult.length != 0) {
      monitoringsimult.map((monitoring) => {
        if (parseInt(monitoring.userout) === parseInt(userout)) {
          erro = 1;
          auxline = monitoring.line;
        } else if (erro != 1) {
          erro = 0;
        }
      });
      if (erro === 1) {
        if (auxline != line) {
          editTypeMonitoring(userout, line, jsoncall);
        }
      } else {
        reduxMonitoringInitial(userin, userout, name, line, ramal, jsoncall);
      }
    } else {
      reduxMonitoringInitial(userin, userout, name, line, ramal, jsoncall);
    }
    // dispatch(ShowInfoDisplay("Monitorias"));
    // dispatch(AlterScreen("Monitorias"));
  };

  // const editTypeMonitoring = (userout, line) => {
  //   dispatch(EditTypeMonitorings(userout, line));
  //   dispatch(EditTypeMonitoringm(userout, line));
  //   dispatch(ShowInfoDisplay("Monitorias"));
  //   dispatch(AlterScreen("Monitorias"));
  // };

  // const reduxMonitoringInitial = (userin, userout, name, line, ramal) => {
  //   dispatch(ShowInfoDisplay("Monitorias"));
  //   dispatch(AlterScreen("Monitorias"));
  //   dispatch(addMonitoring(userout, name, line, ramal));
  //   dispatch(addMonitoringSimult(userout, name, line, ramal));
  //   if (line != "4") {
  //     const socket = InitialMonitoring(userin, userout, line, ramal);
  //   } else {
  //     const socket = SharedScreen(ramal);
  //   }
  // };

  const showModal = (userout, action, reasonaction, duration, status) => {
    const {
      setReasonAction,
      setDuration,
      setHoraAction,
      setAct,
      setActDesb,
      setInable,
      setUserOut,
      setIdSup,
      setIdBlock,
    } = setActionsBlock;

    if (action === "BQSUPER") {
      MicroModal.show("modal__desbloqueio");
      duration = duration.split(" ");
      let horaaction = duration[1].split("-");
      horaaction = horaaction[0];
      duration = duration[0];
      setReasonAction(reasonaction);
      setDuration(duration);
      setHoraAction(horaaction);
      setAct("1001");
      setActDesb("1001");
      setInable(false);
    } else {
      if (status !== null) {
        MicroModal.show("modal__bloqueio");
        setUserOut(userout);
        setAct("1");
        setInable(false);
      } else {
        axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/checkuserblock?iduser=${userout}`
          )
          .then((response) => {
            if (response.data.durationblock === 0) {
              var idreturnblockdescription = response.data.id;
              axios
                .get(
                  `${connection_platform.type_connect}://${pathname}:${port}/conn/checkuserblocksup?iduser=${userout}`
                )
                .then((response) => {
                  MicroModal.show("modal__desbloqueio");

                  setInable(true);
                  duration = response.data.blockingdate.split("T");
                  let horaaction = duration[1].split("-");
                  horaaction = horaaction[0];
                  duration = duration[0];
                  duration = moment(duration, "YYYY-MM-DD").format(
                    "DD/MM/YYYY"
                  );
                  setUserOut(userout);
                  setHoraAction(horaaction);
                  setDuration(duration);
                  setReasonAction(response.data.blockingreason);
                  setIdBlock(idreturnblockdescription);
                  setIdSup(response.data.id);
                })
                .catch((error) => {
                  console.log("trycatch");
                });
            } else {
              setUserOut(userout);
              setAct(act);
              setInable(true);
              MicroModal.show("modal__bloqueio");
            }
          })
          .catch((error) => {
            console.log("trycatch");
          });
      }
    }
  };

  const changeDisplayTransfer = (e, cdrid, serverid, usermon, mediaid) => {
    // document.getElementById("transfer_teste").click();
    setMonitorDash(true);
    // MicroModal.show("modal__transferir__chamada");
    // dispatch(changeTransferQueue("", "dashboardMonitor"));
    localStorage.setItem("idcdr", cdrid);
    localStorage.setItem("serverid", serverid);
    localStorage.setItem("usermon", usermon);
    localStorage.setItem("mediaidTransfer", mediaid);
  };

  const renderOptions = () => {
    return (
      <div className="options-actions">
        <Tooltippy content={"Iniciar conversa"}>
          <div
            className="options-action"
            onClick={() => InitialChat(infos.user)}
          >
            <MessageIcon />

            {/* <span>Iniciar conversa</span> */}
          </div>
        </Tooltippy>

        <Tooltippy content={"Falar com atendente"}>
          <div
            className="options-action"
            onClick={() => InitialCall(ChatSimult, infos.user)}
          >
            <CallIcon />

            {/* <span>Falar com atendente</span> */}
          </div>
        </Tooltippy>

        <Tooltippy content={"Escuta sigilosa"}>
          <div
            className="options-action"
            onClick={() =>
              InitialMonitoringAction(
                InfoUsers.id,
                infos.iduser,
                infos.agente,
                MonitoringSimult,
                "1",
                infos.ramal,
                infos.jsoncall
              )
            }
          >
            <ListeningIcon />

            {/* <span>Escuta sigilosa</span> */}
          </div>
        </Tooltippy>

        <Tooltippy content={"Sussuro"}>
          <div
            className="options-action"
            onClick={() =>
              InitialMonitoringAction(
                InfoUsers.id,
                infos.iduser,
                infos.agente,
                MonitoringSimult,
                "2",
                infos.ramal,
                infos.jsoncall
              )
            }
          >
            <SussurroIcon />

            {/* <span>Sussuro</span> */}
          </div>
        </Tooltippy>

        <Tooltippy content={"Intercalar"}>
          <div
            className="options-action"
            onClick={() =>
              InitialMonitoringAction(
                InfoUsers.id,
                infos.iduser,
                infos.agente,
                MonitoringSimult,
                "3",
                infos.ramal,
                infos.jsoncall
              )
            }
          >
            <PointMessageIcon />

            {/* <span>Intercalar</span> */}
          </div>
        </Tooltippy>

        <Tooltippy content={"Bloquear"}>
          <div
            className="options-action"
            onClick={() => {
              // MicroModal.close("modal__seeAtends");
              showModal(
                infos.iduser,
                infos.user.status_sip,
                infos.user.razao_bloqueio,
                infos.user.duration,
                infos.user.status
              );
            }}
          >
            <BlockIcon />

            {/* <span>Bloquear</span> */}
          </div>
        </Tooltippy>
      </div>
    );
  };

  const renderTableOptions = (cdrid, serverid, iduser, idmidia) => {
    return (
      <ul className="context-menu__list modals">
        <li
          className="contact-info contact-info--with-action"
          onClick={(event) =>
            changeDisplayTransfer(event, cdrid, serverid, iduser, idmidia)
          }
        >
          <Transferir />
          <div className="contact-info__name">Transferir</div>
        </li>

        <li
          className="contact-info contact-info--with-action endAction"
          onClick={(event) => {
            changeDisplayByeChat(cdrid, serverid, iduser, InfoUsers);
            setTimeout(() => {
              handleInfos(infos.iduser, infos.type, cdrid);
            }, 2000);
          }}
        >
          <ENCERRARATENDIMENTO />
          <div className="contact-info__name">Encerrar atendimento</div>
        </li>
      </ul>
    );
  };

  const closeModal = (modal) => {
    MicroModal.close(modal);
    setInfos(false);
  };

  useEffect(() => {
    if (infos && infos.title) {
      handleInfos(infos.iduser, infos.type);
    }
  }, [infos]);

  useEffect(() => {
    if (infoTransfer) {
      handleInfos(infos.iduser, infos.type);
    }
  }, [infoTransfer]);

  return (
    <>
      <div
        className="modal micromodal-slide"
        id="modal__seeAtends"
        aria-hidden="true"
        role="dialog"
      >
        <div className="modal__overlay" tabIndex="-1" style={{ zIndex: 2 }}>
          <div
            className="modal__container"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal__atends__title"
          >
            <div className="modal__see-atends_header">
              <span className="modal__see-atends-title">{infos.title}</span>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  closeModal("modal__seeAtends");
                }}
                className="modal__close"
                aria-label="Close modal"
                data-micromodal-close
              ></button>
            </div>
            <div className="modal__see-atends_body">
              <div className="modal__see-atends_body-infos">
                <div className="modal__see-atends_body-info">
                  <Typography.H6 color={"gray-600"}>Atendente</Typography.H6>
                  <Typography.H4 color={"gray-180"}>
                    {infos.agente}
                  </Typography.H4>
                </div>
                <div className="modal__see-atends_body-info">
                  <Typography.H6 color={"gray-600"}>Ramal</Typography.H6>
                  <Typography.H4 color={"gray-180"}>
                    {infos.ramal}
                  </Typography.H4>
                </div>
                <div className="modal__see-atends_body-info">
                  <Typography.H6 color={"gray-600"}>Grupo</Typography.H6>
                  <Typography.H4 color={"gray-180"}>
                    {infos.grupo}
                  </Typography.H4>
                </div>
                <div className="modal__see-atends_body-info options-info">
                  {renderOptions()}
                </div>
              </div>
              <div className="modal__see-atends_body-container">
                <div className="modal__see-atends_body-table">
                  {dataTable.length > 0 ? (
                    <Table
                      className="table-email"
                      data={dataTable}
                      columns={columns}
                      fixedHeader
                      // fixedFirstColumn
                      // filtersActive={filtersActive}
                      // emptyState={emptyState}
                      // setEmptyState={setEmptyState}
                      initialState={sortBy}
                      rowShadowLine
                    />
                  ) : (
                    <EmptyState />
                  )}
                </div>
                <Typography.H6 color={"gray-200"}>
                  {dataTable.length} Resultado(s)
                </Typography.H6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
